var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pdf)?[_c('iframe',{staticStyle:{"width":"100%","height":"98vh"},attrs:{"src":_vm.pdf}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }